import React, { useState } from 'react';
import axiosInstance from '../../../utils/axios';
import './GroupNotificationForm.css';

const GroupNotificationForm = ({ usergroupId }) => {
  const [formData, setFormData] = useState({
    msg_title: '',
    msg_body: ''
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevState => ({
      ...prevState,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await axiosInstance.post(`/dummy/push-group-comm`, {
        msg_title: formData.msg_title,
        msg_body: formData.msg_body,
        husergroupID: usergroupId,
        from_user_id: "1",
        comms_category:"Testing 2",
        msg_data:"testing 2",
        comms_type: "Group notification"
      });
      
      // Handle successful submission
      console.log('Notification sent successfully:', response.data);
      
      // Clear the form
      setFormData({
        msg_title: '',
        msg_body: ''
      });
      
    } catch (error) {
      console.error('Error sending notification:', error);
    }
  };

  return (
    <div className="notification-form">
      <h3>Send Group Notification</h3>
      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label htmlFor="msg_title">Message Title:</label>
          <input
            type="text"
            id="msg_title"
            name="msg_title"
            value={formData.msg_title}
            onChange={handleChange}
            required
            className="form-control"
          />
        </div>
        
        <div className="form-group">
          <label htmlFor="msg_body">Message Body:</label>
          <textarea
            id="msg_body"
            name="msg_body"
            value={formData.msg_body}
            onChange={handleChange}
            required
            className="form-control"
            rows="4"
          />
        </div>
        
        <button type="submit" className="btn btn-primary">
          Send Notification
        </button>
      </form>
    </div>
  );
};

export default GroupNotificationForm; 